import React from 'react';
import { VideoPlayer } from '~/components/VideoPlayer';
import { Container, CategoryProductsMenu } from './styles';
import { PageTitle } from '~/components/PageTitle';

const ProductCategoryHeaderFiscal = () => {
  return (
    <Container>
      <CategoryProductsMenu>
        <PageTitle>Cardápio Fiscal</PageTitle>
      </CategoryProductsMenu>
    </Container>
  );
};

export default ProductCategoryHeaderFiscal;
